"use client";

import Link from "next/link";
import FooterDisclaimer from "@/app/components/FooterDisclaimer";
import LandingTerminalLink from "./LandingTerminalLink";

const NEWSLETTER_URL = "https://investmentbastion.substack.com";

export function CTABlock() {
  return (
    <section className="relative overflow-hidden">
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 pt-16">
        <div className="liquid-glass rounded-xl p-12 sm:p-16 text-center">
          <h2 className="text-3xl sm:text-4xl font-semibold leading-tight mb-6 text-white">
            Ready to See the Market<br />Without the Noise?
          </h2>
          <p className="text-white/55 mb-8 max-w-lg mx-auto">
            9 multi-factor strategies. 4,000+ global stocks. 13 algo portfolios. Free to start.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <LandingTerminalLink
              href="/hub"
              className="rounded-lg px-8 py-3 text-base font-medium text-black bg-white transition-colors hover:bg-white/90"
            >
              Open Terminal
            </LandingTerminalLink>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function CTAFooterWrapper() {
  const currentYear = new Date().getFullYear();

  return (
    // One gap between page content and the footer on every landing page; pages add no margin of their own.
    <section className="relative overflow-hidden mt-48 md:mt-96 bg-white/[0.025]">
      {/* Footer */}
      <footer className="relative z-10 border-t border-white/10 pt-16 pb-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            {/* Brand */}
            <div>
              <h3 className="text-xl font-semibold mb-3 text-white">Investment Bastion</h3>
              <p className="text-sm text-white/50">Precision tools for better investment decisions.</p>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-sm font-semibold mb-3 text-white/70 uppercase tracking-wider">Navigation</h4>
              <ul className="space-y-2">
                <li>
                  <Link href="/methodology" prefetch className="text-sm text-white/50 hover:text-white/80 transition-colors">
                    Methodology
                  </Link>
                </li>
                <li>
                  <Link href="/pricing" prefetch className="text-sm text-white/50 hover:text-white/80 transition-colors">
                    Plans
                  </Link>
                </li>
                <li>
                  <Link href="/about" prefetch className="text-sm text-white/50 hover:text-white/80 transition-colors">
                    About
                  </Link>
                </li>
                <li>
                  <LandingTerminalLink
                    href="/hub"
                    className="text-sm text-white/50 hover:text-white/80 transition-colors"
                  >
                    Terminal
                  </LandingTerminalLink>
                </li>
                <li>
                  <Link href="/stocks/browse" prefetch className="text-sm text-white/50 hover:text-white/80 transition-colors">
                    Browse stocks
                  </Link>
                </li>
                <li>
                  <a href="/metrics" className="text-sm text-white/50 hover:text-white/80 transition-colors">
                    Metrics Glossary
                  </a>
                </li>
                <li>
                  <a href={NEWSLETTER_URL} target="_blank" rel="noopener noreferrer" className="text-sm text-white/50 hover:text-white/80 transition-colors">
                    Newsletter
                  </a>
                </li>
                <li>
                  <a href="/contact" className="text-sm text-white/50 hover:text-white/80 transition-colors">Contact</a>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h4 className="text-sm font-semibold mb-3 text-white/70 uppercase tracking-wider">Legal</h4>
              <ul className="space-y-2">
                {[
                  { label: "Terms of Service", href: "/terms" },
                  { label: "Refund Policy", href: "/refund" },
                  { label: "Privacy Policy", href: "/privacy" },
                  { label: "Cookie Policy", href: "/cookie-policy" },
                  { label: "Risk Disclaimer", href: "/risk-disclaimer" },
                  { label: "Complaints Policy", href: "/complaints" },
                ].map((link) => (
                  <li key={link.href}>
                    <a href={link.href} className="text-sm text-white/50 hover:text-white/80 transition-colors">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <FooterDisclaimer currentYear={currentYear} />
        </div>
      </footer>
    </section>
  );
}
